import { render, staticRenderFns } from "./AcceptTermsOfUsageField.vue?vue&type=template&id=bb7639c4&scoped=true&"
import script from "./AcceptTermsOfUsageField.vue?vue&type=script&lang=js&"
export * from "./AcceptTermsOfUsageField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7639c4",
  null
  
)

export default component.exports